<template>
  <div class="share">
    <avatar-header :avatar="share && share.coach.avatar" :title="`绑定您的私人教练：${share && share.coach.name}`" />
    <component :is="currentStep.component" v-bind="currentStep.props || {}" @next="nextStep(currentStep.next)" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import AvatarHeader from '@/components/AvatarHeader';
import Course from '@/components/share/Course';
import Unbound from '@/components/share/Unbound';
import Times from '@/components/share/Times';
import Start from '@/components/share/Start';

import { SHARE_TYPE_COURSE, SHARE_TYPE_INVITE, SHARE_TYPE_TRAINER } from '@/constants/types';
import { ROUTE_SHARE_BINDING } from '@/router/names';
import { FETCH_SHARE } from '@/store/share/types';
import { FETCH_WECHAT_USER, FETCH_WECHAT_TRAINER } from '@/store/wechat/types';

import mixinValidator from './validator';

const { mapActions: mapShareActions, mapState: mapShareState } = createNamespacedHelpers('share');
const { mapActions: mapWechatActions, mapState: mapWechatState } = createNamespacedHelpers('wechat');

const STEP_COURSE = 'course';
const STEP_UNBOUND = 'unbound';
const STEP_TIMES = 'times';
const STEP_START = 'start';


export default {
    props: {
        step: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            hash: null,
        };
    },
    computed: {
        ...mapShareState([
            'share',
        ]),
        ...mapWechatState([
            'wechat_user',
            'trainer',
        ]),
        stepCourse() {
            return {
                component: Course,
                props: {
                    hash: this.hash,
                },
            };
        },
        stepUnbound() {
            return {
                component: Unbound,
                props: {
                    hash: this.hash,
                    coach: this.share && this.share.coach,
                },
            };
        },
        stepTimes() {
            return {
                component: Times,
                props: {
                    hash: this.hash,
                    coach: this.share && this.share.coach,
                },
            };
        },
        stepStart() {
            return {
                component: Start,
                props: {
                    hash: this.hash,
                },
            };
        },
        steps() {
            return {
                [STEP_COURSE]: this.stepCourse,
                [STEP_UNBOUND]: this.stepUnbound,
                [STEP_TIMES]: this.stepTimes,
                [STEP_START]: this.stepStart,
            };
        },
        currentStep() {
            if (this.step in this.steps) {
                return this.steps[this.step];
            }
            return this.steps[STEP_UNBOUND];
        },
    },
    async created() {
        this.hash = this.$route.params.hash;

        await Promise.all([
            this.fetchShare({ hash: this.hash }),
            this.fetchUser(),
            this.fetchTrainer(),
        ]);

        if (this.step === null) {
            switch (this.share.type) {
                case SHARE_TYPE_COURSE:
                    this.nextStep(STEP_COURSE);
                    break;
                case SHARE_TYPE_TRAINER:
                    this.$router.replace({
                        name: ROUTE_SHARE_BINDING,
                        params: {
                            hash: this.hash,
                        },
                    });
                    break;
                case SHARE_TYPE_INVITE:
                default:
                    this.nextStep(STEP_UNBOUND);
                    break;
            }
        }
    },
    methods: {
        ...mapShareActions({
            fetchShare: FETCH_SHARE,
        }),
        ...mapWechatActions({
            fetchUser: FETCH_WECHAT_USER,
            fetchTrainer: FETCH_WECHAT_TRAINER,
        }),
        nextStep(step) {
            this.$router.replace({
                name: `share.${step}`,
                params: {
                    hash: this.hash,
                },
            });
        },
    },
    mixins: [
        mixinValidator,
    ],
    components: {
        AvatarHeader,
        Course,
        Unbound,
        Times,
        Start,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/share/Share.vue